import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConnectIcon from "../../assets/image/chat with astrologer.png";
import Ashtakoot from "../../assets/image/Dashakoot.png";
import Western from "../../assets/image/western.png";
import nakshatra from "../../assets/image/nakshatra.png";
import "./matching.css";

const features = [
  { icon: Ashtakoot, label: "Ashtakoot", route: "/Ashtakoot" },
  { icon: nakshatra, label: "Nakshatra", route: "/Nakshatra" },
  { icon: Western, label: "Western", route: "/Western" },
  {
    icon: ConnectIcon,
    label: "Connect with Astrologer",
    route: "/AstrologerSection",
  },
];

function Dashakoot() {
  const navigate = useNavigate();

  const [female, setFemale] = useState({
    name: "Manisha",
    dateofbirth: "1990-05-15",
    timeofbirth: "10:30",
    city: "Delhi",
    latitude: "28.6139",
    longitude: "77.2090",
  });

  const [male, setMale] = useState({
    name: "Rohit",
    dateofbirth: "1988-11-20",
    timeofbirth: "14:45",
    city: "Mumbai",
    latitude: "19.0760",
    longitude: "72.8777",
  });

  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Fetch coordinates based on city input
  const fetchCoordinates = async (city, person) => {
    if (!city) return;
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(city)}`
      );
      const data = await res.json();
      if (data && data[0]) {
        const { lat, lon } = data[0];
        if (person === "female") {
          setFemale((prev) => ({ ...prev, latitude: lat, longitude: lon }));
        } else {
          setMale((prev) => ({ ...prev, latitude: lat, longitude: lon }));
        }
      }
    } catch (err) {
      console.error("Failed to fetch coordinates:", err);
    }
  };

  const handleInputChange = (e, person) => {
    const { name, value } = e.target;
    if (person === "female") {
      setFemale({ ...female, [name]: value });
      if (name === "city") fetchCoordinates(value, "female");
    } else {
      setMale({ ...male, [name]: value });
      if (name === "city") fetchCoordinates(value, "male");
    }
  };

  const fetchDashakoot = () => {
    setError("");
    setResult(null);

    const requiredFields = ["name", "dateofbirth", "timeofbirth", "city"];

    for (let field of requiredFields) {
      if (!female[field]) {
        setError(`Please fill female's ${field}`);
        return;
      }
      if (!male[field]) {
        setError(`Please fill male's ${field}`);
        return;
      }
    }

    setLoading(true);

    const [femaleYear, femaleMonth, femaleDate] = female.dateofbirth.split("-");
    const [femaleHours, femaleMinutes] = female.timeofbirth.split(":");
    const [maleYear, maleMonth, maleDate] = male.dateofbirth.split("-");
    const [maleHours, maleMinutes] = male.timeofbirth.split(":");

    fetch(
      `https://api.jyotishamastroapi.com/api/matching/dashakoot-astro?boy_dob=${maleYear}-${maleMonth}-${maleDate}&boy_tob=${maleHours}:${maleMinutes}&boy_lat=${male.latitude}&boy_lon=${male.longitude}&boy_tz=5.5&girl_dob=${femaleYear}-${femaleMonth}-${femaleDate}&girl_tob=${femaleHours}:${femaleMinutes}&girl_lat=${female.latitude}&girl_lon=${female.longitude}&girl_tz=5.5&lang=en`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",
        },
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`API error: ${res.status}`);
        return res.json();
      })
      .then((data) => setResult(data.response || data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  const kootas = [
    "dina",
    "gana",
    "mahendra",
    "sthree",
    "yoni",
    "rasi",
    "rasiathi",
    "vasya",
    "rajju",
    "vedha",
  ];

  const renderInputs = (personData, person) => {
    const fields = [
      { name: "name", label: "Full Name", type: "text" },
      { name: "dateofbirth", label: "Date of Birth", type: "date" },
      { name: "timeofbirth", label: "Time of Birth", type: "time" },
      { name: "city", label: "City / Place", type: "text" },
    ];

    return fields.map((field) => (
      <div className="matching-form-group" key={field.name}>
        <label>{field.label}</label>
        <input
          type={field.type}
          name={field.name}
          value={personData[field.name]}
          onChange={(e) => handleInputChange(e, person)}
        />
      </div>
    ));
  };

  return (
    <div className="container">
      <div className="ra-main-matchmaking">
        <div className="row">
          <div className="col-md-9">
            <div className="ra-main-Dashakoot">
              <h2>Dashakoot Matching</h2>

              <div className="ra-main-form-section">
                <div className="form-section">
                  <h3>Female Details</h3>
                  <div className="form-grid">{renderInputs(female, "female")}</div>
                </div>

                <div className="form-section">
                  <h3>Male Details</h3>
                  <div className="form-grid">{renderInputs(male, "male")}</div>
                </div>
              </div>

              <button className="match-btn" onClick={fetchDashakoot} disabled={loading}>
                {loading ? "Matching..." : "Match"}
              </button>

              {error && <div className="error-msg">Error: {error}</div>}
              {loading && !error && <div className="loading-msg">Loading...</div>}

              {result && (
                <div className="result-section">
                  <h3>Result</h3>

                  <p style={{ fontSize: "18px", fontWeight: "bold", textAlign: "center", marginBottom: "15px" }}>
                    {male.name} & {female.name}
                  </p>

                  <div className="score-box">
                    <p>
                      <strong>Total Score:</strong> {result.score} / 10
                    </p>
                    {result.bot_response && <p className="bot-response">💡 {result.bot_response}</p>}
                  </div>

                  <div className="koota-grid">
                    {kootas.map((koota) => {
                      const item = result[koota];
                      if (!item) return null;

                      const boyKey = Object.keys(item).find((k) => k.startsWith("boy_"));
                      const girlKey = Object.keys(item).find((k) => k.startsWith("girl_"));

                      return (
                        <div key={koota} className="koota-card">
                          <h4>
                            {item.name} ({item[koota]} / {item.full_score})
                          </h4>
                          <p>
                            <strong>Boy:</strong> {boyKey ? item[boyKey] : "-"}
                          </p>
                          <p>
                            <strong>Girl:</strong> {girlKey ? item[girlKey] : "-"}
                          </p>
                          {item.description && <p className="description">{item.description}</p>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
          
          <div className="col-md-3">
            <div className="ra-Ashtakoot-part2">
              <div className="feature-col">
                {features.map((item, index) => (
                  <div
                    className="feature-card"
                    key={index}
                    onClick={() => navigate(item.route)}
                  >
                    <div className="ra-Ashtakoot-part2-main-box">
                      <div className="ra-Ashtakoot-part2-feature-box">
                        <div
                          className="ra-Ashtakoot-part2-feature-icon"
                          style={{ backgroundColor: item.color }}
                        >
                          <img src={item.icon} alt={item.label} />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* End Sidebar */}
        </div>
      </div>
    </div>
  );
}

export default Dashakoot;
